export enum EventTypes {
    USER_LOGIN = 'user_log_in',
    ACCESS_FLOW_ENTER_DETAILS = 'access_flow_enter_details',
    PAGE_VIEW = 'page_view',
    OPEN_COUNSELING_REPORT = 'open_counseling_report',
    READ_FAQ_ARTICLE = 'read_faq_article',
    ASKED_HELP = 'asked_help',
    CLICKED_QUIZ_QUESTION = 'clicked_quiz_question',
    START_VIDEO = 'start_video',
    WATCHED_VIDEO = 'watched_video',
    WATCHED_25_PERCENT_OF_VIDEO = 'watched_video_25%',
    WATCHED_50_PERCENT_OF_VIDEO = 'watched_video_50%',
    WATCHED_75_PERCENT_OF_VIDEO = 'watched_video_75%',
}

export interface BasicEventPayload {
    customEventData?: Record<string, string | boolean | number>,
    customOrganizationData?: Record<string, string>,
    customUserData?: Record<string, string>,
}

export enum ASKED_HELP_CONTACT_CHANNEL {
  MENU = 'menu',
  CONTACT_US = 'contact_us_section',
}

export enum ANALYTICS_VIDEO_TYPE {
  CONSENT = 'consent',
  RESULTS = 'results',
  LEARNING_CENTER = 'learning_center',
  GENDER_REVEAL = 'gender_reveal',
}
